import {defineMessages} from 'react-intl';

export default defineMessages({
	trackOrderTitle: {
		id: 'trackOrder.pageTitle',
		defaultMessage: 'Track Order page',
	},
	orderPlaced: {
		id: 'trackOrder.orderPlaced',
		defaultMessage: 'Order Placed:',
	},
	status: {
		id: 'trackOrder.status',
		defaultMessage: 'Status:',
	},
	orderNumber: {
		id: 'trackOrder.orderNumber',
		defaultMessage: 'Order Number:',
	},
});
